/**
 * @fileoverview Component that renders the add resource modal
 *
 * @author Benjamin Leitner (bleitner@yext.com)
 */
goog.module('yext.m4.confcode.adminconsole.modal.AddResourceModal');

const {
  resourceTypeToDisplayName,
} = goog.require('yext.m4.confcode.adminconsole.Constants');

const {Input} = goog.require('yext.ui.components.input');
const {Radio} = goog.require('yext.ui.components.Radio');

class AddResourceModal extends React.Component {
  constructor(props) {
    super(props);
    this._resetState = this._resetState.bind(this);
    this._handlePillClick = this._handlePillClick.bind(this);
    this._handleRadioButtonChange = this._handleRadioButtonChange.bind(this);
    this._handleNamespaceInputChange = this._handleNamespaceInputChange.bind(this);
    this._handleFileNameInputChange = this._handleFileNameInputChange.bind(this);
    this._handleCreateResource = this._handleCreateResource.bind(this);
    this._renderModalBodyNavPills = this._renderModalBodyNavPills.bind(this);
    this._renderModalBodyResourceTypeContent = this._renderModalBodyResourceTypeContent.bind(this);
    this._renderModalBody = this._renderModalBody.bind(this);
    this._renderModalFileNameInput = this._renderModalFileNameInput.bind(this);
    this._renderModalFooterButtonsContainer = this._renderModalFooterButtonsContainer.bind(this);
    this._renderModalFooter = this._renderModalFooter.bind(this);

    /** @type {!Props} */
    this.props;

    /** @type {!State} */
    this.state = {
      newResourceNamespace: this.props.namespace,
      selectedResourceType: this.props.selectedNode,
      newResourceFileName: '',
    };
  }

  /**
   * @suppress {strictCheckTypes}
   */
  componentDidUpdate(prevProps) {
    if (this.props.selectedNode !== prevProps.selectedNode
        || this.props.namespace !== prevProps.namespace) {
      this.setState({
        newResourceNamespace: this.props.namespace,
        selectedResourceType: this.props.selectedNode,
        newResourceFileName: '',
      });
    }
  }

  /**
   * @private
   * Resets the state of the add resource modal component.
   */
  _resetState() {
    this.setState({
      newResourceNamespace: '',
      selectedResourceType: this.props.selectedNode,
      newResourceFileName: '',
    });
  }

  /**
   * @private
   * Event handler for when a nav pill is clicked.
   */
  _handlePillClick(e) {
    this.setState({
      selectedResourceType: e.target.name,
      newResourceFileName: '',
    });
  }

  /**
   * @private
   * Event handler for when the selected raio button is changed.
   */
  _handleRadioButtonChange(e) {
    this.setState({
      selectedResourceType: e.target.value,
      newResourceFileName: '',
    });
  }

  /**
   * @private
   * Event handler for when the input namespace is changed.
   */
  _handleNamespaceInputChange(value) {
    this.setState({
      newResourceNamespace: value,
    });
  }

  /**
   * @private
   * Event handler for when the input file name is changed.
   */
  _handleFileNameInputChange(value) {
    this.setState({
      newResourceFileName: value,
    });
  }

  /**
   * @private
   * Event handler for when a key is pressed in the file input. Submit if it's enter key.
   */
  _handleFileInputEnter(event, isInputValid) {
    // check for enter key
    if (event['keyCode'] === 13 && isInputValid && this.state.newResourceFileName !== '') {
      this._handleCreateResource(
        this.state.newResourceNamespace,
        this.state.selectedResourceType,
        this.state.newResourceFileName + '.json');
      $('#close-modal').click();
    }
  }

  /**
   * @private
   * Event handler for when the create resource button is clicked.
   */
  _handleCreateResource(namespace, resourceType, fileName) {
    this._resetState();
    this.props.onCreate(namespace, resourceType, fileName);
  }

  /**
   * @private
   * Renders the nav plls for the modal body.
   */
  _renderModalBodyNavPills() {
    const {resourceTypeMapping} = this.props;

    return (
      <div
        className="nav flex-column nav-pills"
        id="v-pills-tab"
        role="tablist"
        aria-orientation="vertical"
      >
        {Object.keys(resourceTypeMapping).map((key, index) => {
          const isSelected = this.state.selectedResourceType.startsWith(key);
          return (
            <a
              key={index}
              className={isSelected ? 'nav-link active' : 'nav-link'}
              id={'v-pills-' + key + '-tab'}
              data-toggle="pill"
              href={'#v-pills-' + key}
              role="tab"
              aria-controls={'v-pills-' + key}
              aria-selected={isSelected ? 'true' : 'false'}
              name={key}
              onClick={this._handlePillClick}
            >
              {resourceTypeToDisplayName[key]}
            </a>
          );
        })}
      </div>
    );
  }

  /**
   * @private
   * Renders the resource type content for the modal body.
   */
  _renderModalBodyResourceTypeContent() {
    return (
      <div className="tab-content" id="v-pills-tabContent">
        {Object.entries(this.props.resourceTypeMapping).map(([key, value]) => {
          const isSelected = this.state.selectedResourceType.startsWith(key);
          return (
            <div
              key={key}
              className={isSelected ? 'tab-pane fade show active' : 'tab-pane fade'}
              id={'v-pills-' + key}
              role="tabpanel"
              aria-labelledby={'v-pills-' + key + '-tab'}
            >
              {value.map((resourceType, index) => {
                const fullPathResourceType = key + '/' + resourceType;
                const isChecked = this.state.selectedResourceType === fullPathResourceType;
                const resourcTypeUniqueIdentifier = '-add';
                return (
                  // eslint-disable-next-line
                  <Radio
                    id={fullPathResourceType + resourcTypeUniqueIdentifier}
                    label={resourceType}
                    value={fullPathResourceType}
                    name="resource-type-radios"
                    onChange={this._handleRadioButtonChange}
                    checked={isChecked}
                  />
                );
              })}
            </div>
          );
        })}
      </div>
    );
  }

  /**
   * @private
   * Renders the body of the add resource modal.
   */
  _renderModalBody() {
    return (
      <div className="modal-body r-modal-body">
        <div className="row">
          <div className="col-4">
            {this._renderModalBodyNavPills()}
          </div>
          <div className="col-8">
            {this._renderModalBodyResourceTypeContent()}
          </div>
        </div>
      </div>
    );
  }

  /**
   * @private
   * Renders the input for entering the file name.
   */
  _renderModalFileNameInput(isInputValid, shouldDisable) {
    const resourceTypeSpanContent = this.state.selectedResourceType && !this.props.showResourceTypePath
      ? '/' + this.state.selectedResourceType
      : this.state.selectedResourceType;
    return (
      <div className="row">
        {!this.props.showResourceTypePath && <Input /* eslint-disable-line yext/a11y-empty-input-label */ label=""
          id="namespace"
          placeholder="Namespace (optional)"
          value={this.state.newResourceNamespace}
          onChange={this._handleNamespaceInputChange}
          disabled={shouldDisable}
          valid={isInputValid}
          onKeyUp={event => this._handleFileInputEnter(event, isInputValid)}
        />
        }
        <span>{resourceTypeSpanContent}/</span>
        <Input /* eslint-disable-line yext/a11y-empty-input-label */ label=""
          id="file-name"
          placeholder="Enter file name"
          value={this.state.newResourceFileName}
          onChange={this._handleFileNameInputChange}
          disabled={shouldDisable}
          valid={isInputValid}
          onKeyUp={event => this._handleFileInputEnter(event, isInputValid)}
        />
        <span>.json</span>
      </div>
    );
  }

  /**
   * @private
   * Renders the buttons container for footer of the modal.
   */
  _renderModalFooterButtonsContainer(isInputValid, shouldDisable) {
    const isResourceFileNameEmpty = this.state.newResourceFileName === '';
    return (
      <div className="row add-resource-buttons-container">
        <button
          type="button"
          className="btn btn-cancel"
          data-dismiss="modal"
          onClick={() => this._resetState()}
        >
          Cancel
        </button>
        <button
          type="submit"
          className="btn btn-primary"
          data-dismiss="modal"
          onClick={() => this._handleCreateResource(
            this.state.newResourceNamespace,
            this.state.selectedResourceType,
            this.state.newResourceFileName + '.json')}
          disabled={shouldDisable || !isInputValid || isResourceFileNameEmpty}
        >
          Create
        </button>
      </div>
    );
  }

  /**
   * @private
   * Renders the footer of the add resource modal.
   */
  _renderModalFooter(newResourceRelativePath, isInputUnique, inputContainSlash, shouldDisable) {
    const isInputValid = isInputUnique && !inputContainSlash;
    return (
      <div className="modal-footer r-modal-footer">
        {!isInputUnique
          && <div className="row error-message">
            <p>{newResourceRelativePath} already exists</p>
          </div>
        }
        {inputContainSlash
          && <div className="row error-message">
            <p>New resource file names cannot contain "/" characters</p>
          </div>
        }

        {this._renderModalFileNameInput(isInputValid, shouldDisable)}
        {this._renderModalFooterButtonsContainer(isInputValid, shouldDisable)}
      </div>
    );
  }

  /**
  * @private
  *
  * Determines if the selected resource type is a valid type to add
  *
  * @param {string} selectedResourceType  the selected resource type
  * @returns {boolean} true if it is valid
  */
  _isValidResourceTypeToAdd(selectedResourceType) {
    const [resourceType, subType] = selectedResourceType.split('/', 2);
    if (!this.props.resourceTypeMapping[resourceType]) {
      return false;
    }

    return this.props.resourceTypeMapping[resourceType].filter(sub => subType === sub).length > 0;
  }

  render() {
    const namespaceToCheck = this.state.newResourceNamespace === ''
                               ? 'default'
                               : this.state.newResourceNamespace;
    const newResourceRelativePath =
      namespaceToCheck + '/' +
      this.state.selectedResourceType + '/' +
      this.state.newResourceFileName + '.json';
    const isInputUnique = !this.props.relativePaths.includes(newResourceRelativePath);
    const inputContainSlash = this.state.newResourceFileName.indexOf('/') > -1;
    const shouldDisable = !this._isValidResourceTypeToAdd(this.state.selectedResourceType);

    return (
      <div>
        <div
          className="modal fade"
          id="add-resource-modal"
          tabIndex="-1"
          role="dialog"
          aria-labelledby="modal-title"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content r-dialog-content">
              <div className="modal-header">
                <h5 className="modal-title" id="modal-title">Add Resource</h5>
                <button type="button" id="close-modal" className="close" data-dismiss="modal" aria-label="Close">
                  <span
                    aria-hidden="true"
                    className="x-icon"
                    onClick={() => this._resetState()}
                  >
                  </span>
                </button>
              </div>
              {this._renderModalBody()}
              {this._renderModalFooter(
                newResourceRelativePath,
                isInputUnique,
                inputContainSlash,
                shouldDisable)}
            </div>
          </div>
        </div>

        {/* TODO (bleitner): Figure out how to use the boostrap modal method directly, instead of using a button */}
        <button
          type="button"
          className="r-add-resource-modal-toggle"
          data-toggle="modal"
          data-target="#add-resource-modal"
          style={{display: 'none'}}
        >
        </button>
      </div>
    );
  }
}

/** @record */
class Props {
  constructor() {
    /**
     * The ID of the selected node.
     * @type {!string}
     */
    this.selectedNode;

    /**
     * The array of relative paths.
     * @type {!Array<string>}
     */
    this.relativePaths;

    /**
     * The namespace of the selected node.
     * @type {!string}
     */
    this.namespace;

    /**
     * The function to be called to create the new file.
     * @type {function(!string, !string, !string)}
     */
    this.onCreate;

    /**
     * A map of resource types by their groups (ex: km or m4).
     *@type {!Object}
     */
    this.resourceTypeMapping;

    /**
    * If the resource to be created should be specified by resource type path rather than namespace.
    * @type {!boolean}
    */
    this.showResourceTypePath;
  }
}

/** @record */
class State {
  constructor() {
    /**
     * The namespace of the new resource.
     * @type {!string}
     */
    this.newResourceNamespace;

    /**
     * The selected resource type.
     * @type {!string}
     */
    this.selectedResourceType;

    /**
     * The file name of the new resource.
     * @type {!string}
     */
    this.newResourceFileName;
  }
}

exports = AddResourceModal;
